export const ROOT = "/admin/otp-report";
